<template>
  <div class="upload-id-card">

    <!-- 名字 -->
    <div class="title">
      {{idCard.elec_name}}
      <div class="s-ocr-label">OCR</div>

      <!--  -->
      <fliggy-select-file-btn
        v-if="!forbidUpload(idCard.upload[0])"
        class="m-l-20"
        :order="order"
        :applicant="applicant"
        :material-name="idCard.elec_name"
        :max-select-num="1"
        btn-text="从飞猪资料包选取(人像面)"
        @confirm="onUploadByFliggy($event, 0)"
      ></fliggy-select-file-btn>
      <fliggy-select-file-btn
        v-if="!forbidUpload(idCard.upload[1])"
        class="m-l-20"
        :order="order"
        :applicant="applicant"
        :material-name="idCard.elec_name"
        :max-select-num="1"
        btn-text="从飞猪资料包选取(国徽面)"
        @confirm="onUploadByFliggy($event, 1)"
      ></fliggy-select-file-btn>
    </div>

    <div class="content">

      <!-- 没有身份证 -->
      <div class="special-status">
        <div class="special-title">
          <el-checkbox v-model="applicant.is_id_card_special" :disabled="disableCardSpecialCheck" @change="changeIDCardSpecial">没有身份证</el-checkbox>
        </div>
        <div class="select-items" v-show="applicant.is_id_card_special" @change="changeIDCardSpecialStatus">
          <el-radio-group v-model="applicant.id_card_special_status">
            <el-radio v-for="(v,k) in IDCardSpecialStatus" :label="k" :key="k" :disabled="disableCardSpecialCheck">{{v}}</el-radio>
          </el-radio-group>
        </div>

        <!-- 资料不完善备注 -->
        <memo class="special-memo" v-if="applicant.is_id_card_special && idCard.upload[0].memo" :memo-content="idCard.upload[0].memo"></memo>
      </div>

      <!-- 主体 -->
      <div class="upload-body">

        <div class="id-card-upload-area">
          <div class="id-card-page">

            <!-- 上传 -->
            <upload-item class="upload-item" :img-url="idCard.upload[0].url" :upload="idCard.upload[0]"
              :forbid="forbidUpload(idCard.upload[0])"
              :verify-passed="idCard.upload[0].elec_status === consts.ELEC_STATUS.qualified_0"
              :verify-not-pass="idCard.upload[0].elec_status === consts.ELEC_STATUS.unqualified_3"
              :is-reupload="isReupload"
              @saveUploadInputId="saveUploadInputId"
              @uploadFile="file => uploadIdCard(file, 0)" @reviewImage="reviewImage"></upload-item>

            <!-- 分割线 -->
            <div v-if="!idCard.upload[0].url" class="dashed-line"></div>

            <template v-if="!idCard.upload[0].url">

              <!-- 示例 -->
              <sample class="sample-box" :sample-url="sampleUrl.front" @click.native="reviewImage(sampleUrl.front, 'sample', idCard)"></sample>

              <!-- 注意事项 -->
              <attention class="attention-box" :attention="idCard.attention"></attention>

            </template>

            <template v-else>
              <ocr-info
                ref="infoDetail0"
                :infoData="idcardaInfo"
                @updateOrder="updateOrder"
                type="idcarda"
                :forbid="forbidUpload(idCard.upload[0])"
                :currentMaterial="idCard"
                :applicantId="applicant.order_applicant_id"
                :shouldShowEdit="idCard.upload[0].elec_status !== 3 && idCard.upload[0].elec_status !== 0"
                :orderId="order.user_order_id">
              </ocr-info>
            </template>

          </div>

          <!-- 资料不完善备注 -->
          <memo class="simple-memo" v-if="!applicant.is_id_card_special && idCard.upload[0].memo" :memo-content="idCard.upload[0].memo"></memo>

          <div class="id-card-page">

            <!-- 上传 -->
            <upload-item class="upload-item" :img-url="idCard.upload[1].url" :upload="idCard.upload[1]"
              :forbid="forbidUpload(idCard.upload[1])"
              :verify-passed="idCard.upload[1].elec_status === consts.ELEC_STATUS.qualified_0"
              :verify-not-pass="idCard.upload[1].elec_status === consts.ELEC_STATUS.unqualified_3"
              @saveUploadInputId="saveUploadInputId"
              @uploadFile="file => uploadIdCard(file, 1)" @reviewImage="reviewImage"></upload-item>

            <!-- 分割线 -->
            <div v-if="!idCard.upload[1].url" class="dashed-line"></div>

            <template v-if="!idCard.upload[1].url">

              <!-- 示例 -->
              <sample class="sample-box" :sample-url="sampleUrl.back" @click.native="reviewImage(sampleUrl.back, 'sample', idCard)"></sample>

            </template>

            <template v-else>
              <ocr-info
                ref="infoDetail1"
                :infoData="idcardbInfo"
                @updateOrder="updateOrder"
                type="idcardb"
                :currentMaterial="idCard"
                :forbid="forbidUpload(idCard.upload[1])"
                :applicantId="applicant.order_applicant_id"
                :shouldShowEdit="idCard.upload[1].elec_status !== 3 && idCard.upload[1].elec_status !== 0"
                :orderId="order.user_order_id">
              </ocr-info>
            </template>

          </div>

          <!-- 资料不完善备注 -->
          <memo class="simple-memo" v-if="!applicant.is_id_card_special && idCard.upload[1].memo" :memo-content="idCard.upload[1].memo"></memo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uploadFileService from '../../services/upload-file-service';
import orderService from '../../services/order-service';
import uploadService from '../../services/upload-service';

import status from '../../libs/status';
import Http from '../../libs/http';

import materialConstants from '../../constants/material-constants';

import uploadItem from './upload-item';
import sample from './sample';
import attention from './attention';
import memo from './memo';
import applicantConstants from '../../constants/applicant-constants';
import frontSample from '../../assets/imgs/upload/id-card-front-sample.png';
import backSample from '../../assets/imgs/upload/id-card-back-sample.png';
import ocrInfo from '../../components/upload/ocr-info/ocr-info';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';
import fileService from '../../services/file-service';
import utils from '../../libs/utils';

export default {
  name: 'uploadIdCard',
  components: {
    uploadItem,
    sample,
    attention,
    memo,
    ocrInfo,
    FliggySelectFileBtn,
  },
  props: {
    idCard: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      sampleUrl: {
        front: frontSample,
        back: backSample,
      },
      IDCardSpecialStatus: status.IDCardSpecialStatus,
      consts: {
        ELEC_STATUS: materialConstants.ELEC_STATUS,
      },
      originIdcardaInfo: {
        fullname: '',
        id_no: '',
        gender: '',
        nation: '',
        birthday: '',
        address: '',
      },
      originIdcardbInfo: {
        issue_authority: '',
        issue_date: '',
        expire_date: '',
      },
      idcardaInfo: {
        fullname: '',
        id_no: '',
        gender: '',
        nation: '',
        birthday: '',
        address: '',
      },
      idcardbInfo: {
        issue_authority: '',
        issue_date: '',
        expire_date: '',
      },
    };
  },
  computed: {

    // 身份证，选择特殊情况，资料合格后，不可再编辑和保存资料
    // 身份证，上传正反面图片，两张图片都不合格，状态为”资料不完善“，官网可以重新上传图片或选择”没有身份证“；
    // 只有一张合格，则不能再选择特殊情况，只能上传不合格的那一张图片；如两张都合格，则任何状态下，都不能修改
    disableCardSpecialCheck() {
      // 重新上传才可能禁用
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const applicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;
        const bothIdCardNotPassOrWaittingForVerify = this.idCard.upload.every(upload => upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3
            || upload.elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2);
        const isIdCardSpecial = this.idCard.upload[0].special_code > 0;
        const onlyOneIdCardPassed =
          (this.idCard.upload[0].elec_status === materialConstants.ELEC_STATUS.unqualified_3
            && this.idCard.upload[1].elec_status === materialConstants.ELEC_STATUS.qualified_0) ||
          (this.idCard.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0
            && this.idCard.upload[1].elec_status === materialConstants.ELEC_STATUS.unqualified_3);

        // 身份证特殊状态
        if (isIdCardSpecial) {
          // 特殊状态预审合格
          const isMaterialVerifyPassed = this.idCard.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0;

          // 如果通过
          if (isMaterialVerifyPassed) {
            // 不能操作
            return true;
          }

          // 特殊状态没有合格

          // 如果同时申请人资料不完善
          if (applicantVerifyNotPass) {
            // 才可以编辑
            return false;
          }

          // 不然就看着
          return true;
        }

        // 非特殊状态下，就是至少上传了两张身份证照片

        // 如果两张的都没通过
        if (bothIdCardNotPassOrWaittingForVerify) {
          // 申请人资料不完善
          if (applicantVerifyNotPass) {
            // 就可以选上面
            return false;
          }

          // 否则也不行
          return true;
        }

        // 不是两张都不合格,(包含两张都合格，或者只有一张合格，一张不合格)

        // 如果只有一张合格，此时不能再选择上面的特殊状态
        if (onlyOneIdCardPassed) {
          return true;
        }

        // 上传了身份证的两张照片，资料不完善，然后点击 “没有身份证”，上传一张图片之后，也不能禁用
        const isOnlyUploadedOneImg = (this.idCard.upload[0].url && !this.idCard.upload[1].url) || (!this.idCard.upload[0].url && this.idCard.upload[1].url);
        if (isOnlyUploadedOneImg) {
          return false;
        }

        // 两张都合格
        return true;
      }

      return false;
    },
  },
  methods: {

    // 能不能上传
    forbidUpload(upload) {
      // 重新上传要判断申请人状态
      if (this.isReupload) {
        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return this.applicant.is_id_card_special;
        }

        const isApplicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，不能上传
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!upload.url);

        // 代码执行到这里，说明已经支付了，并且是资料不完善。
        // 如果地址为空，且选择了有身份证，则可以上传
        if (isEmptyUpload && !this.applicant.is_id_card_special) {
          // 有可能压根没选“没有身份证”这个选项
          return false;
        }

        // 身份证预审合格
        const isIdcardVerifyPassed = upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;
        // 如果选择了没有身份证或者预审合格，则不能上传
        return this.applicant.is_id_card_special || isIdcardVerifyPassed;
      }
      return this.applicant.is_id_card_special || upload.elec_status === materialConstants.ELEC_STATUS.qualified_0;
    },

    // 改变身份证的特殊状态
    changeIDCardSpecialStatus() {
      this.idCardSpecialSave();
    },

    // 切换是否有身份证
    changeIDCardSpecial() {
      if (this.applicant.id_card_special_status === '0') {
        this.applicant.id_card_special_status = '1';
        this.idCardSpecialSave();
      }
    },

    // 保存身份证特殊状态
    idCardSpecialSave() {
      Http.post('/applicant_elec_special_handle', {
        elec_id: this.idCard.elec_id,
        order_applicant_id: this.applicant.order_applicant_id,
        user_order_id: this.applicant.user_order_id,
        special_code: +this.applicant.id_card_special_status,
      }).then(() => {
        orderService.clearApplicantIdCardUpload(
          this.applicant,
          materialConstants.ELEC_STATUS.waittingForVerified_2,
          +this.applicant.id_card_special_status,
        );
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 上传身份证
    uploadIdCard(file, index) {
      this.idCard.upload[index].file = file;

      // 设置loading状态
      this.$set(this.idCard.upload[index], 'loading', true);
      // 上传
      uploadFileService.uploadOcrMaterial(this.idCard.upload[index].file, index ? 'idcardb' : 'idcarda')
        .then((data) => {
          if (data) {
            this.idCard.upload[index] && this.$set(this.idCard.upload[index], 'loading', false);
            if (data.cropped_image) {
              delete data.cropped_image;
            }

            if (!index && !data.id_no) {
              this.$message.error('请上传清晰的身份证人像面');
              return Promise.reject();
            }
            if (index && !data.issue_authority) {
              this.$message.error('请上传清晰的身份证国徽面');
              return Promise.reject();
            }
            this.idCard.upload[index].url = data.url;
            // this.$emit('getInfo', { data, type: index ? 'idcardb' : 'idcarda' });
            if (index) {
              this.idcardbInfo = Object.assign({}, this.idcardbInfo, this.originIdcardbInfo, { ...data, isConfirm: this.idCard.upload[1].elec_status !== 1 });
              this.uploadIdcardInfoStandBy(index, this.idcardbInfo);
            } else {
              this.idcardaInfo = Object.assign({}, this.idcardaInfo, this.originIdcardaInfo, { ...data, isConfirm: this.idCard.upload[0].elec_status !== 1 });
              this.uploadIdcardInfoStandBy(index, this.idcardaInfo);
            }
            this.$nextTick(() => {
              if (this.$refs[`infoDetail${index}`]) this.$refs[`infoDetail${index}`].initData();
            });
          }
        })
        .catch((e) => {
          if (e) console.log(e);
          this.idCard.upload[index] && this.$set(this.idCard.upload[index], 'loading', false);
        });
    },

    // 飞猪资料上传
    async onUploadByFliggy({ key_list }, index) {
      const key = key_list[0];
      const file = await utils.downloadUrlToFile(fileService.getOssFullUrl(key));
      this.uploadIdCard(file, index);
    },

    // 预览图片
    reviewImage(src) {
      this.$emit('reviewImage', src);
    },
    saveUploadInputId(id) {
      this.$emit('saveUploadInputId', id);
    },
    updateOrder() {
      this.$emit('updateOrder');
    },
    uploadIdcardInfoStandBy(index, data) {
      const upload_url = `/applicant_id_card_${index === 0 ? 'front' : 'back'}_save`;
      Http.post(upload_url, {
        order_applicant_id: this.applicant.order_applicant_id,
        ...data,
        isConfirm: undefined,
      })
        .then(() => {
          this.$emit('updateOrder');
          this.$message({
            message: '上传成功',
            type: 'success',
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
    // 获取身份证信息
    getIdcardInfo() {
      Http.post('/applicant_id_card_query', {
        order_applicant_id: this.applicant.order_applicant_id,
        user_order_id: this.order.user_order_id,
      })
        .then((data) => {
          this.idcardaInfo = Object.assign({}, this.idcardaInfo, { ...data, isConfirm: this.idCard.upload[0].elec_status !== 1, url: this.idCard.upload[0].url });
          this.idcardbInfo = Object.assign({}, this.idcardbInfo, { ...data, isConfirm: this.idCard.upload[1].elec_status !== 1, url: this.idCard.upload[1].url });
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
  },
  created() {
    if (this.idCard && this.idCard.upload && (this.idCard.upload[0].url || this.idCard.upload[1].url)) {
      this.getIdcardInfo();
    }
  },
};
</script>

<style lang="less">
.special-status {
  .el-checkbox__label {
    padding-left: 10px;
  }
  .el-radio__label {
    padding-left: 6px;
  }
  .el-radio + .el-radio {
    margin-left: 80px;
  }
}
</style>


<style lang="less" scoped>
@import '../../assets/less/variable';
.upload-id-card {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    font-size: 18px;
    color: #333;
    display: flex;
    align-items: center;
  }
  .content {
    padding:  0 30px 30px 30px;
    .special-status {
      border-bottom: 1px solid @border;
      padding-bottom: 20px;
      .select-items {
        margin-top: 23px;
        margin-left: 26px;
      }
      .special-memo {
        margin: 20px 0 0 0;
      }
    }
    .upload-body {
      display: flex;
      .id-card-upload-area {
        display: flex;
        flex-direction: column;
        flex: 1;
        .id-card-page {
          display: flex;
          margin-top: 30px;
          .upload-item {
            &.have-img {
              width: 400px;
              height: 218px;
            }
            width: 348px;
            height: 218px;
            margin-right: 30px;
          }
          .dashed-line {
            width: 1px;
            height: 218px;
            background-color: white;
            border-right: 1px dashed @border;
            margin-left: 20px;
            margin-right: 50px;
          }
          .sample-box {
            width: 200px;
            height: 125px;
          }
          .attention-box {
            margin-left: 30px;
            flex: 1;
          }
        }
        .simple-memo {
          margin-top: 20px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/upload/upload-id-card.vue